import { CircularProgress } from '@mui/material';
import { FlexDiv } from 'crono-fe-common/components/Layout/FlexDiv';
import { useAccountDrawer } from 'context/accountDrawer';
import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import PATH from 'crono-fe-common/constants/path';

const OpportunityInterceptor = () => {
  const [searchParams] = useSearchParams();
  const { dealId } = useParams();
  const accountId = searchParams.get('accountId') ?? undefined;
  const { openDealDrawer } = useAccountDrawer();

  const navigate = useNavigate();

  useEffect(() => {
    navigate(PATH.DEALS);

    if (!accountId || !dealId) {
      console.error(
        `Tried opening deal but found accountId: ${accountId} and dealId: ${dealId}`,
      );
      return;
    }

    openDealDrawer({
      accountId,
      opportunityId: dealId,
    });
  }, [accountId, dealId]);

  return (
    <FlexDiv>
      <CircularProgress />
    </FlexDiv>
  );
};

export default OpportunityInterceptor;
